import { forwardRef } from "react";
import { Label } from "../Label/Label";
import { InputProps } from "../types";
import { findError } from "../util";
import { FormFieldError } from "../FormFieldError/FormFieldError";
import {
  BASE_INPUT_COLORS,
  READ_ONLY_CLASSES,
  SIZE_MAP,
  STYLE_MAP
} from "../styles";

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      hideLabel = false,
      margin = "mb-5",
      errors,
      description,
      descriptionType,
      helperText,
      inputSize = "regular",
      className = "",
      mode = "light",
      variant = "filled",
      ...inputProps
    },
    ref
  ) => {
    const { name } = inputProps;

    const error = findError(name, errors);

    return (
      <div className={`${margin} ${className}`}>
        {!hideLabel && (
          <Label
            label={label}
            name={name}
            description={description}
            descriptionType={descriptionType}
            mode={mode}
          />
        )}

        <input
          className={`${STYLE_MAP[mode][variant].primary} ${SIZE_MAP[inputSize]} ${BASE_INPUT_COLORS} ${READ_ONLY_CLASSES} block w-full rounded align-left `}
          id={inputProps.name}
          ref={ref}
          {...inputProps}
        />
        {helperText && (
          <p className={`${STYLE_MAP[mode]["text"].secondary} text-xs mt-1`}>
            {helperText}
          </p>
        )}
        {error && (
          <FormFieldError error={error.message?.toString() || "required"} />
        )}
      </div>
    );
  }
);
